import { ReactElement } from 'react';

import {
  OnlyLoggedIn,
  useRedirectIfNotAllowed,
} from 'components/auth/Redirects';
import Layout from 'components/layout/Layout';
import { LOGGED_IN_HOME_PATH } from 'lib/paths';
import { Box, Text, VStack } from '@chakra-ui/react';
import { useIsHorsScope } from 'lib/hooks/queries';

const AccueilSwitch = () => {
  const { isHorsScope } = useIsHorsScope();

  useRedirectIfNotAllowed(LOGGED_IN_HOME_PATH, isHorsScope);

  return (
    <Box bg={'white'} borderRadius={10}>
      <VStack alignItems="center">
        <Text fontSize="4xl" as="b" align={'center'} m={4}>
          Tu n'es pas encore en Première ou Terminale, nous t'addendons à ce
          moment-là !
        </Text>
      </VStack>
    </Box>
  );
};

AccueilSwitch.getWrappers = (page: ReactElement) => {
  return (
    <Layout variant="minimal" rowVariant="yellow">
      <OnlyLoggedIn>{page}</OnlyLoggedIn>
    </Layout>
  );
};
export default AccueilSwitch;
